import { useQuery } from '@tanstack/react-query';
import { factoryGetOfficesCountByStateKey } from '../factories/queries/factoryGetOfficesCountByStateKey';
import { OfficesService } from '../services/OfficesService';
import { IOfficesCountByStateResponse } from '../types/IOfficesCountByStateResponse';

const FIVE_MINUTES = 5 * 60 * 1000;

interface IUseGetOfficesCountByStateOptions {
  enable?: boolean;
}

export const useGetOfficesCountByState = (
  state: string | undefined,
  options: IUseGetOfficesCountByStateOptions = {},
) => {
  const { enable = true } = options;

  const { data, isLoading, isFetching, isError } = useQuery<IOfficesCountByStateResponse>({
    queryKey: factoryGetOfficesCountByStateKey({ state }),
    queryFn: () => OfficesService.getOfficesCountByState({ state: state! }),
    enabled: enable && !!state,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: FIVE_MINUTES,
  });

  return {
    count: data?.count,
    isLoading: isLoading || isFetching,
    isError,
  };
};
